import {CreateLeadApiDto} from "../../api/model/rest";
import JsonConverter from "../../api/helper/JsonConverter";
import TrackingData from "./TrackingData";
import {Option} from "ts-option";

export default class LeadData {
	constructor(public readonly siteId: Option<string>,
		public readonly principalContactId: string,
		public readonly description: Option<string>,
		public readonly extendedDescription: Option<string>,
		public readonly categoriesIds: string[],
		public readonly acquisitionChannelId: Option<string>,
		public readonly leadTypeId: string,
		public readonly tracking: Option<TrackingData>,
		public readonly payByFinance: boolean) {}

	toJson(): CreateLeadApiDto {
		const json: CreateLeadApiDto = {
			siteId: this.siteId.orNull,
			contactId: this.principalContactId,
			description: this.description.orNull,
			extendedDescription: this.extendedDescription.orNull,
			categories: this.categoriesIds,
			acquisitionChannelId: this.acquisitionChannelId.orNull,
			leadTypeId: this.leadTypeId,
			tracking: this.tracking.map(t => t.toJson()).orNull,
			payByFinance: this.payByFinance
		};
		return JsonConverter.removeEmptyFields(json);
	}

	copy({
		siteId = this.siteId,
		principalContactId = this.principalContactId,
		description = this.description,
		extendedDescription = this.extendedDescription,
		categoriesIds = this.categoriesIds,
		acquisitionChannelId = this.acquisitionChannelId,
		leadTypeId = this.leadTypeId,
		tracking = this.tracking,
		payByFinance = this.payByFinance
	}) {
		return new LeadData(siteId,
			principalContactId,
			description,
			extendedDescription,
			categoriesIds,
			acquisitionChannelId,
			leadTypeId,
			tracking,
			payByFinance);
	}
}